import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchAreasQuery } from '@/features/areas'
import { fetchAreasList } from '@/features/areas/api'

import { AreasSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/areas/'
)({
  validateSearch: (search) => parse(AreasSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchAreasQuery(tenantKey, deps)
    return {
      authUser: auth.user,
      areas: await fetchAreasList(query, abortController.signal)
    }
  }
})
